import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { IconNotificationFilled } from '@prisjakt/ui/icon/notification-filled';
import { IconNotificationOutlined } from '@prisjakt/ui/icon/notification-outlined';
import { ButtonIcon, ButtonSize } from '@prisjakt/ui/button';
import {
  StyledButtonText,
  StyledTooltip,
  StyledButton,
} from '../shared-styles';

export const AlertButton: React.FC<AlertButtonProps> = ({
  isActive,
  onClick,
}) => {
  const { t } = useAppContext();

  return (
    <StyledTooltip
      title={t('product', 'action-button.alert-tooltip')}
      zIndex={1}
    >
      <StyledButton
        ariaLabel={t('product', 'alert.create-button')}
        onClick={onClick}
        size={ButtonSize.SMALL}
      >
        <ButtonIcon>
          {isActive ? <IconNotificationFilled /> : <IconNotificationOutlined />}
        </ButtonIcon>
        <StyledButtonText>
          {t('product', 'alert.create-button')}
        </StyledButtonText>
      </StyledButton>
    </StyledTooltip>
  );
};

interface AlertButtonProps {
  isActive: boolean;
  onClick?: () => void;
}
